<button (click)="onCheckbox()" [style.min-width.px]="minWidth" [style.gap.px]="gap || 12">
  @if (textOrientation === 'left' && text) {
    <span [ngStyle]="textStyle" #contentContainer>
      {{ text }}
    </span>
  }

  <div
    class="checkbox-container"
    [class.container-checked]="animationsEnabled() && (control?.value || checked)"
    [class.container-unchecked]="animationsEnabled() && !(control?.value || checked)"
    [style.width.px]="width"
    [style.height.px]="width"
  >
    @if (control?.value || checked) {
      <img
        class="checkbox-img"
        [class.checkbox-checked]="animationsEnabled()"
        [src]="'assets/img/icons/checkbox-checked-' + color + '.svg'"
        [style.width.px]="width"
        [style.height.px]="width"
      />
    } @else if (width > 20) {
      <img
        class="checkbox-img"
        [class.checkbox-unchecked]="animationsEnabled()"
        [src]="'assets/img/icons/checkbox-unchecked.svg'"
        [style.width.px]="width"
        [style.height.px]="width"
      />
    }
  </div>

  @if (textOrientation === 'right' && text) {
    <span [ngStyle]="textStyle" #contentContainer>
      {{ text }}
    </span>
  }
</button>
